import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box, Image, P, ResponsiveSVG } from 'ui/acro'
import {
  CardSubtitle,
  CardTitle,
  TitleContainer
} from 'components_v1/SchemaSectionRenderer/common/styles'
import TimeCodeBadge from 'components_v1/SchemaSectionRenderer/common/components/TimeCodeBadge'
import ClassCountBadge from 'components_v1/SchemaSectionRenderer/common/components/ClassCountBadge'
import { AlomovesIconSVG } from 'images/latest'
import { LIKED_ITEMS_SLUG } from 'components_v1/common'
import CommonLink from 'components_v2/CommonLink'

const Main = styled(CommonLink)`
  .no-image {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f2f2f2;
    aspect-ratio: 16/9;
  }
`

const PlaylistCard = ({
  id,
  uuid,
  coverPhoto,
  duration,
  classCount,
  title,
  author,
  onClickHandler
}) => {
  let image
  if (typeof coverPhoto !== 'undefined') {
    image = coverPhoto
  }

  return (
    <Main
      id={id}
      flexDirection='column'
      position='relative'
      style={{ minWidth: '173px' }}
      to={`/playlists/${uuid}?source=mypractice`}
    >
      {image ? (
        <Box position='relative' mb={['8px', '10px']}>
          <Image
            src={image}
            objectFit='cover'
            position='absolute'
            top='0'
            left='0'
            style={{ aspectRatio: '16/9' }}
          />
          {uuid !== LIKED_ITEMS_SLUG && typeof classCount === 'number' && (
            <ClassCountBadge bottom='16px !important' left='16px !important'>
              {`${classCount} Class${classCount <= 1 ? '' : 'es'}`}
            </ClassCountBadge>
          )}

          {duration && (
            <TimeCodeBadge
              fontSize='13px !important'
              bottom='16px !important'
              left='100px !important'
            >
              {duration}
            </TimeCodeBadge>
          )}
        </Box>
      ) : (
        <Box mb={['8px', '10px']} className='no-image'>
          <ResponsiveSVG
            width={['68px', '68px', '130px', '130px']}
            height={['68px', '68px', '130px', '130px']}
            SVG={AlomovesIconSVG}
            className='no-thumbnail'
          />
        </Box>
      )}
      <TitleContainer>
        {title && (
          <CardTitle
            id='PlaylistTitle'
            as='div'
            paddingBottom='6px'
            style={{
              fontSize: '18px',
              fontWeight: '400',
              textTransform: 'capitalize',
              width: 'calc(100% - 40px)',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {title}
          </CardTitle>
        )}
        {uuid !== LIKED_ITEMS_SLUG && (
          <P
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()

              onClickHandler()
            }}
          >
            • • •
          </P>
        )}
      </TitleContainer>

      {author.firstName && (
        <CardSubtitle as='div'>
          {author.firstName} {author.lastName}
        </CardSubtitle>
      )}
    </Main>
  )
}

PlaylistCard.propTypes = {
  duration: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  classCount: PropTypes.number,
  title: PropTypes.string.isRequired,
  coverPhoto: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired
}

export default PlaylistCard
